<mat-dialog-content>
  <header class="d-flex jcsb align-baseline">
    <h1>Vertrag nr. 2025-xxxxx-xx</h1>
    <img src="/phoenix-logo.png"/>
  </header>
  <article [innerHTML]="data.body_html"></article>
  <footer> Seite {{data.sort_index + 1}} von n</footer>
</mat-dialog-content>
